import { getConfig } from '@edx/frontend-platform';
import Cookies from 'js-cookie';

function parseJSON(text) {
  let json = {};

  try {
    json = JSON.parse(text);
  } catch (error) {
    json = {};
  }

  return json;
}

export function inactiveRedirection302Middleware(axios) {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const { code = '', url = '' } = parseJSON(
        error?.customAttributes?.httpErrorResponseData,
      );

      if (
        error?.customAttributes?.httpErrorStatus === 302
        && code === 'inactive_user'
      ) {
        window.location.replace(url);
      }

      return Promise.reject(error);
    },
  );
}

export function logout401And403Middleware(axios) {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const { detail = '' } = parseJSON(
        error?.customAttributes?.httpErrorResponseData,
      );

      const errorCode = error?.customAttributes?.httpErrorStatus;

      if (
        errorCode === 401 || (
          errorCode === 403
          && detail.includes('Authentication credentials were not provided')
        )
      ) {
        Cookies.remove('csrftoken');
        window.location.replace(getConfig().LOGOUT_URL);
      }

      return Promise.reject(error);
    },
  );
}
